


































































import Vue from "vue";
import { FIcon, FStaticField, FMessageBox } from "@fkui/vue";
import { EReceipt } from "@exp/vue";
import { focus } from "@fkui/logic";
import dayjs from "dayjs";
import { ROUTES } from "@/router";

export default Vue.extend({
    name: "Receipt",
    components: {
        FIcon,
        EReceipt,
        FStaticField,
        FMessageBox,
    },
    async beforeRouteLeave(to, from, next): Promise<void> {
        if (to.path === ROUTES.APPLICATION.path) {
            this.receiptError = true;
            await this.$nextTick();
            this.focusErrorElement();
            next(false);
        } else {
            next();
        }
    },
    props: {
        name: {
            type: String,
            required: false,
            default: undefined,
        },
        phone: {
            type: String,
            required: false,
            default: undefined,
        },
        email: {
            type: String,
            required: false,
            default: undefined,
        },
        requested: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            receiptError: false,
        };
    },
    computed: {
        showContactInformation(): boolean {
            return !!(this.name || this.phone || this.email);
        },
        date(): string {
            return dayjs().format("YYYY-MM-DD");
        },
    },
    created(): void {
        window.onbeforeunload = () => true;

        history.scrollRestoration = "manual";
        if (!this.requested) {
            throw new Error("Request must have been sent");
        }
    },
    mounted(): void {
        this.receiptError ? this.focusErrorElement() : this.focusTopHeading();
    },
    methods: {
        printOrSave() {
            window.print();
        },
        focusTopHeading(): void {
            const heading = document.getElementsByClassName("rubrik-valbar-ikon")[0];
            if (heading instanceof HTMLElement) {
                this.focusAndScrollTo(heading);
            }
        },
        async focusErrorElement(): Promise<void> {
            const kvittensError = document.getElementById("receipt-error");
            if (kvittensError instanceof HTMLElement) {
                this.focusAndScrollTo(kvittensError);
            }
        },
        focusAndScrollTo(element: HTMLElement): void {
            focus(element, true);
            //setTimeout is needed for zoom and scroll issues in Chrome.
            setTimeout(() => element.scrollIntoView());
        },
    },
});
